export default () => (dispatch, getState) => dispatch({
    type: 'MODAL_DISMISSED'
})
